const miniHowItWorksStyle = {
  section_wrapper: `w-full py-[30px] lg:py-[50px] flex flex-col items-center justify-center relative overflow-hidden`,
  container: `w-full flex flex-col items-center justify-center px-6 md:px-12 relative overflow-hidden`,
  header_wrpr: `flex flex-col items-center justify-center gap-3 w-full mb-12 md:mb-16 select-none`,
  heading: `font-Suisse font-[900] uppercase text-[26px] leading-[34px] tracking-tight text-white text-center
            screen-500:text-[35px] screen-500:leading-[42px]
            sm:text-[41px] sm:leading-[48px]
            md:text-[45px] md:leading-[54px]`,
  highlight: `text-primaryHeading`,
  list_container: `flex flex-col gap-8 md:gap-10 max-w-[650px] md:max-w-[750px] w-full mx-auto px-2 md:px-4`,
  step_row: `flex items-start gap-4 md:gap-6 justify-start group cursor-default`,
  icon_circle: `min-w-[48px] w-[48px] h-[48px] rounded-full border border-zinc-800 bg-[#07092c] flex items-center justify-center text-white transition-all duration-300 group-hover:border-primaryHeading group-hover:text-primaryHeading group-hover:scale-105 shadow-md`,
  content_wrpr: `flex flex-col gap-1.5`,
  title: `text-white font-inter font-bold text-[15px] leading-[22px] md:text-[17px] md:leading-[24px] uppercase tracking-wide transition-colors duration-300 group-hover:text-primaryHeading`,
  text: `text-zinc-400 font-inter font-light text-[13px] leading-[20px] md:text-[14px] md:leading-[22px] max-w-[620px] transition-colors duration-300 group-hover:text-zinc-300`,
};

export { miniHowItWorksStyle };
